<template lang="pug">
v-container.py-15
  custom-title.text-center.mb-8 Produtos
  carousel.mb-6.page-home-products(
    v-if="brands.length",
    :nav="false",
    :margin="10",
    :responsive="brandsCarouselResponsive"
  )
    brand-card(
      v-for="({ id, img, title, to }, i) in brands",
      :key="i",
      :to="'/produtos?b=' + id",
      :img="img",
      :title="title"
    )
  template(v-if="!loading")
    div
      grid-container.justify-center(
        cols="repeat(auto-fit, minmax(auto, 150px))",
        cols-sm="repeat(auto-fit, minmax(auto, 220px))"
      )
        template(v-for="(item, i) in categories")
          category-card(v-if="i < itemsPerPage", :key="i", v-bind="item")
    .d-flex.justify-center
      v-btn.mt-8.px-10(to="/produtos", color="primary", tile, outlined, large) VER TODOS
  .py-10.d-flex.justify-center(v-else)
    v-progress-circular(size="50", color="primary", indeterminate)
</template>

<script>
import CustomTitle from "../../others/CustomTitle.vue";
import BrandCard from "../../cards/Brand.vue";
import CategoryCard from "../../cards/Category.vue";
import carousel from "vue-owl-carousel";

export default {
  data: () => ({
    loading: true,
    products: [],
  }),
  created() {
    const brands = this.$rest("brands").get();
    const categories = this.$rest("products-categories").get({
      params: {
        featured: 1,
      },
    });

    Promise.all([brands, categories]).finally(() => (this.loading = false));
  },
  computed: {
    brands() {
      return this.$rest("brands").list.map(({ id, img, title }) => ({
        id,
        img: img ? this.files + "/" + img : "",
        title,
        to: `/produtos?b=${id}`,
      }));
    },
    brandsCarouselResponsive() {
      return {
        0: { items: 2 },
        300: { items: 3 },
        600: { items: 6 },
        1200: { items: 9 },
      };
    },
    categories() {
      return this.$rest("products-categories").list.map(
        ({ id, img, title }) => ({
          img,
          title,
          to: "/produtos?c=" + id,
        })
      );
    },
    itemsPerPage() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 4;
        case "sm":
          return 6;
        case "md":
          return 9;
        case "lg":
          return 12;
        default:
          return 14;
      }
    },
  },
  components: {
    CustomTitle,
    CategoryCard,
    BrandCard,
    carousel,
  },
};
</script>

<style>
.page-home-products .owl-stage {
  margin: 0 auto !important;
}
</style>
